import React from 'react';
import { Badge } from '../badge';
import { getBundleBadgeTooltipContent } from './bundle-badge.utils';
import { useEssentials } from '../../../contexts/essentials-context';
import { Box } from '@wix/design-system';
export function BundleBadge({ isInstalled, isCouponTypeBundle, appName, showBorder, size = 'small', }) {
    const { t } = useEssentials();
    return (React.createElement(Badge, { skin: "neutralSuccess", dataHook: "bundle-badge", uppercase: false, showBorder: showBorder, size: size, tooltipContent: getBundleBadgeTooltipContent({
            t,
            isInstalled: isInstalled ?? false,
            isCouponTypeBundle,
            appName: appName ?? '',
        }) },
        React.createElement(Box, null, t('solutionBox.badge.bundle'))));
}
//# sourceMappingURL=bundle-badge.js.map